<template>
    <EmailField
        :errors="null"
        @keyup:enter="loginHandler"
        v-model="email"
        :showLabel="false"
    />

    <PasswordField
        :errors="null"
        @keyup:enter="loginHandler"
        v-model="pass"
        :showLabel="false"
    />

    <button
        @click="loginHandler"
        :disabled="isLoginDisabled || loading"
        class="
            p-2.5 bg-won-green text-white w-full flex justify-center
            items-center rounded mt-4 hover:opacity-90
            disabled:opacity-40 disabled:bg-won-gray relative
        "
    >
        <span
            class="text-white"
            :class="{'opacity-0' : loading}"
        >
            Login
        </span>

        <span class="absolute" v-if="loading">
            <LoadingIcon
                :class="{'opacity-0' : !loading}"
            />
        </span>
    </button>
</template>

<script setup>
import { shallowRef, computed, toRefs } from 'vue';

import PasswordField from "../password-field.vue";
import EmailField from "../email-field.vue";
import LoadingIcon from "../../../icons/loading-icon.vue";

const emit = defineEmits(["login"]);
const props = defineProps({
    loading: {
        type: Boolean,
        default: false
    }
})

const { loading } = toRefs(props);

const email = shallowRef(null);
const pass = shallowRef(null);

const loginHandler = () => {
    emit('login', {
        email: email.value,
        password: pass.value,
    })
}

const isLoginDisabled = computed(() => {
    return email.value == null || email.value === '' || loading.value === true
        || pass.value == null || pass.value === ''
})
</script>
